module.exports = __webpack_public_path__ + "img/logo.bc7a8ab0.png";